import { useQueryDecoratedSilo } from 'app/queries/decoratedSilo';
import { ReactNode } from 'react';
import { useThisSiloAddress } from './hooks';
import { useThisNullableSilo } from './useThisSilo';

/**
 * This is a simulated version of the actual suspense component. Using actual
 * suspense requires thoughtful use of error boundaries, and also gets
 * complicated for dependent queries, so deferring it for now.
 */
interface SuspenseProps {
  fallback: ReactNode;
  children?: ReactNode;
}

export function Suspense({ fallback, children }: SuspenseProps): JSX.Element {
  const siloAddress = useThisSiloAddress();
  const { data } = useQueryDecoratedSilo(siloAddress);
  const result = useThisNullableSilo();

  if (result.status === 'loading' || !data) return <>{fallback}</>;

  return <>{children}</>;
}
